import React, { Component, PureComponent, Fragment } from 'react'
import { Message } from 'semantic-ui-react'

export default function ErrorAggregator({ items }) {
  let errors = []

  for (let name in items) {
    if (items[name]) {
      errors.push({
        name,
        message: items[name],
      })
    }
  }

  if (!errors.length) return null

  return (
    <div className="error-aggregator">
      {errors.map(({ name, message }) => (
        <Message negative key={name}>
          <Message.Header>{name}</Message.Header>
          <p>{message}</p>
        </Message>
      ))}
    </div>
  )
}
